<template>
    <div>
        <LocationSelector :locations="locations" :value="value.locations" @input="updateLocations" />
        <PeriodSelector :value="value.period" @input="updatePeriod" />
    </div>
</template>

<script>
import LocationSelector from './common/LocationSelector.vue';
import PeriodSelector from './common/PeriodSelector.vue';
import { createUpdaters } from '../widgetHelpers';

export default {
    name: 'TargetTimeForm',

    components: {
        LocationSelector,
        PeriodSelector,
    },

    props: {
        locations: {
            type: Array,
            required: true,
        },

        value: {
            type: Object,
            required: true,
        },
    },

    methods: createUpdaters('period', 'locations'),
};
</script>
